export default {
    theme: 'dark',
    autoSync: false,
    showAllLinkLabels: false,
    kultStyle: false
};